import { useStaticQuery, graphql } from "gatsby"

export const useMenu = locale => {
    // console.log(locale)
    const menu = useStaticQuery(graphql`
    query UseMenuQuery {
      allDatoCmsMenu(
        filter: {
          root: { eq: true }
        }
        sort: { fields: [position], order: ASC }
      ) {
        nodes {
          id
          locale
          name
          link {
            ... on DatoCmsLink {
                id
                anchor
                url
                openInNewWindow
            }
            ... on DatoCmsPageLink {
                id
                name
                page {
                    id
                    slug
                }
            }         
          }
          treeChildren {
            position
            id
            locale
            name
            link {
                ... on DatoCmsLink {
                    id
                    anchor
                    url
                    openInNewWindow
                }
                ... on DatoCmsPageLink {
                    id
                    name
                    page {
                        id
                        slug
                        treeParent {
                            id
                            slug
                        }
                    }
                }         
            }
          }
        }
      }
    }
  `)

    const currentLocaleMenu = menu.allDatoCmsMenu.nodes
        .filter(menu => menu.locale === locale)
        .map(menu => {
            menu.treeChildren.sort((a, b) => a.position - b.position);
            return menu;
        })

    return currentLocaleMenu
}
